
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'

@Component
export default class AnswerItem extends Vue {
  @Prop()
  message!: string

  onClick(e: Event) {
    this.$emit('click', e, this)
  }
}
